import { Component, OnInit } from '@angular/core';
import { DelegateDto } from '@models/users/delegate.dto';
import { MessageService } from '@services/message.service';
import { SubscriberService } from '@services/subscriber.service';
import { ConfirmationService, TreeNode } from 'primeng/api';

@Component({
  selector: 'ebs-organization-chart-view',
  templateUrl: './organization-chart-view.component.html',
  styleUrls: ['./organization-chart-view.component.scss'],
})
export class OrganizationChartViewComponent implements OnInit {
  selectedNodes: TreeNode<DelegateDto> | null = null;

  public data: TreeNode<DelegateDto>[] = [];

  constructor(
    private subscriberService: SubscriberService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    this.subscriberService.getOrganizationChartInfo().subscribe((nodes) => {
      this.data = nodes.map((node) => {
        return this.getTreeNode(
          node,
          nodes.filter((elem) => elem.upperDelegateId === node.delegateId),
          nodes,
        );
      });
    });
  }

  getTreeNode(
    orgChart: DelegateDto,
    children: DelegateDto[],
    originalArr: DelegateDto[],
  ) {
    let treeNode: TreeNode = {};
    treeNode.data = orgChart;
    treeNode.expanded = true;
    treeNode.type = 'person';
    treeNode.children = children.map((node) => {
      return this.getTreeNode(
        node,
        originalArr.filter((elem) => node.delegateId === elem.upperDelegateId),
        originalArr,
      );
    });

    return treeNode;
  }

  onDetailClosed() {
    this.selectedNodes = null;
  }
}
